import NavBar from "../NavBar";
import "../messages.css";
import "../pop2.css";

const Markets = () => {
    return(
        <div className="desktop-13">
          <div className="screenshot-3151">
          </div>
            <NavBar />
            <div className="coming-soon">Coming Soon...</div>
        </div>
    )
}

export default Markets;